import clsx, { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'


export function classnames(...classes: ClassValue[]): string {
  // clsx ensures any level nested arrays are converted into a single string
  // then, twMerge ensures that the last spec wins if there are conflicting classes
  const classArray = clsx(...classes).split(' ').filter(Boolean);
  const uniqueClasses = Array.from(new Set(classArray.toReversed())).toReversed();
  return twMerge(uniqueClasses.join(' '));
}
